import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id ECC94305-DFA6-4D9B-85C8-CC79F3F05FB5
 * name lightbulb
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb.svg
 * tags
 * - Home Automation 
 */
export const LightbulbIcon = createSvgIcon(<><path d="M12,2A7,7 0 0,0 5,9C5,11.38 6.19,13.47 8,14.74V17A1,1 0 0,0 9,18H15A1,1 0 0,0 16,17V14.74C17.81,13.47 19,11.38 19,9A7,7 0 0,0 12,2M9,21A1,1 0 0,0 10,22H14A1,1 0 0,0 15,21V20H9V21Z" /></>, 'LightbulbIcon');
export default LightbulbIcon